var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CREATE_PREFIX_REQUEST, CREATE_PREFIX_SUCCESS, CREATE_PREFIX_ERROR } from "../actions/createPrefix";
import { ADD_STEP_PREFIX_REQUEST, ADD_STEP_PREFIX_SUCCESS, ADD_STEP_PREFIX_ERROR } from '../actions/addStepPrefix';
export var initialState = {
    isFetching: false,
    isError: false,
    data: {},
};
export function createPrefix(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CREATE_PREFIX_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case CREATE_PREFIX_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case CREATE_PREFIX_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        case ADD_STEP_PREFIX_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case ADD_STEP_PREFIX_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case ADD_STEP_PREFIX_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
//# sourceMappingURL=createPrefix.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CREATE_PREFIX_REQUEST, CREATE_PREFIX_SUCCESS, CREATE_PREFIX_ERROR } from "../actions/createPrefix";
import { ADD_STEP_PREFIX_REQUEST, ADD_STEP_PREFIX_SUCCESS, ADD_STEP_PREFIX_ERROR } from '../actions/addStepPrefix';
export var initialState = {
    isFetching: false,
    isError: false,
    data: {},
};
export function createPrefix(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CREATE_PREFIX_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case CREATE_PREFIX_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case CREATE_PREFIX_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        case ADD_STEP_PREFIX_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case ADD_STEP_PREFIX_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case ADD_STEP_PREFIX_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
//# sourceMappingURL=createPrefix.js.map